import './App.scss';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import SetPassword from './pages/SetPassword';
import ResetPassword from './pages/ResetPassword';

import ProtectedRoute from './components/admin/ProtectedRoute';

import Integration from './pages/Integration';
import TeamJeeraInsights from './pages/JiraDashboard';
import GitDashboard from './pages/GitDashboard';
import QMetirxBeta from './pages/QMetrixBeta';
import CapacityDashboard from './components/capacityPlanning/capacityPlanning';
import RolesBillingTable from './components/capacityPlanning/Roles&Billing';
import StandUpPage from './pages/StandUpPage';
import MultiProjectSelectionPage from './pages/MultiProjectSelectionPage';
import ReleaseDashboard from './pages/ReleaseDashboard';
import TechQuality from './pages/TechQuality';
import HolidayList from './components/capacityPlanning/HolidayList';
import ChatbotWidget from './components/AI/ChatbotWidget';
import AdminProjectAccess from './pages/AdminProjectAccess';
import AdminRoleManagement from './pages/AdminRoleManagement';
import SuperAdminWorkspaceManagement from './pages/SuperAdminWorkspaceManagement';

function ThemeSync() {
  const theme = useSelector((state) => state.theme.theme);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  return null;
}

const guard = (path, element) => (
  <ProtectedRoute path={path}>
    {element}
  </ProtectedRoute>
);

// Create router once
const router = createBrowserRouter([
  {
    path: '/',
    element: <Login />,
  },
  {
    path: '/forgotPassword',
    element: <ForgotPassword />,
  },
  {
    path: '/resetPassword/:token',
    element: <ResetPassword />,
  },
  {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/setPassword',
    element: <SetPassword />,
  },
  {
    path: '/dashboard',
    element: guard('/dashboard', <QMetirxBeta />),
  },
  {
    path: '/standUp',
    element: guard('/standUp', <StandUpPage />),
  },
  {
    path: '/multiProjectSelection',
    element: guard(
      '/multiProjectSelection',
      <MultiProjectSelectionPage />
    ),
  },
  {
    path: '/release',
    element: guard('/release', <ReleaseDashboard />),
  },
  {
    path: '/techQuality',
    element: guard('/techQuality', <TechQuality />),
  },
  {
    path: '/integration',
    element: guard('/integration', <Integration />),
  },
  {
    path: '/gitDashboard',
    element: guard('/gitDashboard', <GitDashboard />),
  },
  {
    path: '/jiraDashboard',
    element: guard('/jiraDashboard', <TeamJeeraInsights />),
  },
  {
    path: '/capacityPlanning',
    element: guard('/capacityPlanning', <CapacityDashboard />),
  },
  {
    path: '/Roles&Billing',
    element: guard('/Roles&Billing', <RolesBillingTable />),
  },
  {
    path: '/HolidayList',
    element: guard('/HolidayList', <HolidayList />),
  },
  {
    path: '/admin/project-access',
    element: guard('/admin/project-access', <AdminProjectAccess />),
  },
  {
    path: '/admin/roles',
    element: guard('/admin/project-access', <AdminRoleManagement />),
  },
  {
    path: '/admin/workspaces',
    element: guard('/admin/workspaces', <SuperAdminWorkspaceManagement />),
  },
]);

function App() {
  return (
    <>
      <ThemeSync />

      {/* <RouterProvider router={route}></RouterProvider>
      <ChatbotWidget /> */}
      <RouterProvider router={router} />
            <ChatbotWidget />



      {/* Single app-wide ToastContainer */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable={false}
        limit={3}
      />
    </>
  );
}

export default App;
